import type { MenuConfig } from '~typings/menu'

import permisosImportaciones, { RESOURCE_IMPORTACIONES } from '@/auth/permissions/modules/importacionesPg'
import * as names from '@routes/importaciones-pg/nombres/mantenimiento'

const { mantenimiento } = permisosImportaciones

export default [
    {
        title: 'importaciones.subopciones.gestion_impuestos',
        route: names.ROUTE_GESTION_IMPUESTOS,
        resource: RESOURCE_IMPORTACIONES,
        action: mantenimiento.gestionImpuestos,
    },
    {
        title: 'importaciones.subopciones.gestion_divisas',
        route: names.ROUTE_GESTION_DIVISAS,
        resource: RESOURCE_IMPORTACIONES,
        action: mantenimiento.gestionDivisas,
    },
    {
        title: 'importaciones.subopciones.gestion_regimenes_aduaneros',
        route: names.ROUTE_GESTION_REGIMENES_ADUANEROS,
        resource: RESOURCE_IMPORTACIONES,
        action: mantenimiento.gestionRegimenesAduaneros,
    },
] satisfies MenuConfig[]
